module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', [_vm._v("Single")]), _vm._v(" "), _c('mt-checkbox', {
    attrs: {
      "id": "item-0",
      "label": "Label",
      "checked": _vm.item0
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Indeterminate")]), _vm._v(" "), _c('div', {
    staticClass: "indeterminate-checkbox"
  }, [_c('mt-checkbox', {
    attrs: {
      "id": "item-4",
      "label": "Label",
      "type": "indeterminate"
    },
    model: {
      value: (_vm.item4),
      callback: function($$v) {
        _vm.item4 = $$v
      },
      expression: "item4"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Group")]), _vm._v(" "), _vm._l((_vm.groupData), function(item) {
    return _c('mt-checkbox', {
      key: item.id,
      staticClass: "group-checkbox",
      attrs: {
        "id": item.id,
        "label": item.item
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "style"
  }, [_c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.colors,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h3', [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizing,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Checkbox")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', {
    staticClass: "text-style"
  }, [_vm._v("Checked:")]), _vm._v(" "), _c('p', [_vm._v("Background: #055AFE")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Hover:")]), _vm._v(" "), _c('p', [_vm._v("Border: #055AFE ")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Unchecked:")]), _vm._v(" "), _c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Checked disable:")]), _vm._v(" "), _c('p', [_vm._v("Background: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Text: #B2C0D0")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Unchecked disable:")]), _vm._v(" "), _c('p', [_vm._v("Background: #EDEFF3")]), _vm._v(" "), _c('p', [_vm._v("Border: #055AFE ")]), _vm._v(" "), _c('p', [_vm._v("Text: #B2C0D0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Corner radius: 1px")]), _vm._v(" "), _c('p', [_vm._v("Width: 18px")]), _vm._v(" "), _c('p', [_vm._v("Height: 18px")]), _vm._v(" "), _c('p', [_vm._v("Border: 1px")]), _vm._v(" "), _c('p', [_vm._v("Text: 14px")]), _vm._v(" "), _c('p', [_vm._v("Horizontal padding: 10px")]), _vm._v(" "), _c('p', [_vm._v("Vertical padding: 15px")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f09e8b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkbox.vue
// module id = fty4
// module chunks = 0